import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import MessagePropType from '../definitions/MessagePropType';
import DeleteConfirmationBlock from './DeleteConfirmationBlock';
import FullScreenTakeover, { DISPLAY_MODES } from './FullScreenTakeover';


function WarningModal({
    isOpen = true,

    titleMessage,
    descriptionMessage,
    confirmMessage,
    rejectMessage,

    onConfirmClick,
    onRejectClick,

    name,
    displayMode = DISPLAY_MODES.LIGHTBOX,
}) {

    return (
        <FullScreenTakeover
            isOpen={isOpen}
            showBranding={false}
            screenReaderLabel={(
                <FormattedMessage
                    id="base-ui.WarningModal.warningScreenReader"
                    defaultMessage="Warning modal"
                />
            )}
            displayMode={displayMode}
        >
            <DeleteConfirmationBlock
                name={name}

                titleMessage={titleMessage}
                descriptionMessage={descriptionMessage}
                confirmMessage={confirmMessage}
                rejectMessage={rejectMessage}
                        
                onConfirmClick={onConfirmClick}
                onRejectClick={onRejectClick}
            />
        </FullScreenTakeover>
    );
}

WarningModal.propTypes = {
    isOpen: PropTypes.bool,

    titleMessage: MessagePropType.isRequired,
    descriptionMessage: MessagePropType,
    confirmMessage: MessagePropType.isRequired,
    rejectMessage: MessagePropType.isRequired,

    onConfirmClick: PropTypes.func.isRequired,
    onRejectClick: PropTypes.func.isRequired,

    name: PropTypes.string,
    displayMode: PropTypes.oneOf(
        Object.values(DISPLAY_MODES),
    ),
};


export default WarningModal;